import axios from "axios";

const API = "/api";

const TOKEN_KEY = "vk_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const client = axios.create({ baseURL: API });

// Bearer-Token automatisch an jede Anfrage anhängen
client.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Bei abgelaufener/ungültiger Sitzung global ausloggen
client.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401 && getToken()) {
      window.dispatchEvent(new Event("vk-unauthorized"));
    }
    return Promise.reject(error);
  }
);

// Backend kann [] oder { tasks: [] } liefern -> immer Array
const toArray = (data) => (Array.isArray(data) ? data : Array.isArray(data?.tasks) ? data.tasks : []);

export const tasksApi = {
  list: () => client.get("/tasks").then((r) => toArray(r.data)),
  create: (payload) => client.post("/tasks", payload).then((r) => r.data),
  update: (id, payload) => client.put(`/tasks/${id}`, payload).then((r) => r.data),
  remove: (id) => client.delete(`/tasks/${id}`).then((r) => r.data),
  removeCompleted: () => client.delete("/tasks/completed").then((r) => r.data),
  removeAll: () => client.delete("/tasks/all").then((r) => r.data),
  transcribe: (blob, lang) => {
    const fd = new FormData();
    fd.append("file", blob, "audio.webm");
    if (lang) fd.append("language", lang);
    return client.post("/transcribe", fd).then((r) => r.data.text);
  },
};

export const authApi = {
  register: (name, email, password) =>
    client.post("/auth/register", { name, email, password }).then((r) => r.data),
  login: (email, password) =>
    client.post("/auth/login", { email, password }).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  updateProfile: (payload) => client.put("/auth/me", payload).then((r) => r.data),
  logout: () => client.post("/auth/logout").then((r) => r.data),
};

export default client;
